var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectorSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8758 15.2821L11.7811 11.1874C12.8295 10 13.4737 8.44421 13.4737 6.73684C13.4737 3.02316 10.4505 0 6.73684 0C3.02316 0 0 3.02316 0 6.73684C0 10.4505 3.02316 13.4737 6.73684 13.4737C8.44211 13.4737 9.99789 12.8316 11.1874 11.7811L15.2821 15.8758C15.3642 15.9579 15.4716 16 15.5789 16C15.6863 16 15.7937 15.9579 15.8758 15.8758C16.04 15.7116 16.04 15.4442 15.8758 15.28V15.2821ZM6.73684 12.6316C3.48632 12.6316 0.842105 9.98737 0.842105 6.73684C0.842105 3.48632 3.48632 0.842105 6.73684 0.842105C9.98737 0.842105 12.6316 3.48632 12.6316 6.73684C12.6316 9.98737 9.98737 12.6316 6.73684 12.6316Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectorSearch);
export default __webpack_public_path__ + "static/media/selector-search.d8a341221ae0d0da9dfd315725ab600c.svg";
export { ForwardRef as ReactComponent };